export default "__VITE_ASSET__B9I3JIDC__"